var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#CAC4D0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2212_61091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 17.8469C20.4145 17.8469 16.2562 20.3557 13.1878 24.4305C12.9374 24.7644 12.9374 25.2308 13.1878 25.5646C16.2562 29.6444 20.4145 32.1532 25 32.1532C29.5855 32.1532 33.7438 29.6444 36.8122 25.5695C37.0626 25.2357 37.0626 24.7693 36.8122 24.4354C33.7438 20.3557 29.5855 17.8469 25 17.8469ZM25.3289 30.0372C22.2851 30.2286 19.7714 27.7199 19.9629 24.6711C20.12 22.1574 22.1574 20.12 24.6711 19.9629C27.7149 19.7714 30.2286 22.2802 30.0371 25.329C29.8751 27.8377 27.8377 29.8752 25.3289 30.0372ZM25.1767 27.7101C23.537 27.8132 22.182 26.4631 22.29 24.8233C22.3734 23.4683 23.4732 22.3735 24.8282 22.2851C26.4679 22.182 27.823 23.5321 27.7149 25.1719C27.6266 26.5318 26.5268 27.6266 25.1767 27.7101Z",
    fill: "#CAC4D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2212_61091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.bc57283b.svg";
export { ForwardRef as ReactComponent };